// ESM-Huelle fuer lib/scripts/components/CMP_CContainerColumn.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CContainerColumn (id)
{
    this.construct (id);

    this.name = "CContainerColumn";    
    this.htmlType = "td";

    this.properties =
    {
        styles:{},
/*        {
            verticalAlign: "middle",
            textAlign: "center",
            emptyCells: "show"
        },*/
        events: {},
        attributes: {}
    }
}

CContainerColumn.prototype = new CComponent;

export { CContainerColumn };
